/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Reason } from 'src/app/_model/reason';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class ReasonsDaoService implements Resetable {
  public abstract saveReasons(reasons: Reason[]): Promise<void>;
  public abstract getReasons(): Promise<Reason[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}